import React, { useMemo } from "react";
import Slider from "react-slick";
import { CustomArrow } from "./../index";
import { Text } from './../../atoms';
import styled from "styled-components";
import PropTypes from "prop-types";
import { lighten } from "polished";

const Carousel = ({ className, children, shouldStretchVertical }) => {
  const lineBreak = "\n";
  // remove lineBreaks
  const filteredImages = useMemo(
    () => children.length > 0 ? children.filter(element => element !== lineBreak) : [children],
    [children]
  );

  return (
    <Slider
      tabIndex={-1}
      useTransform={false}
      slidesToShow={1}
      slidesToScroll={1}
      speed={500}
      infinite={false}
      centerMode={false}
      centerPadding={0}
      dots={false}
      initialSlide={0}
      prevArrow={
        <CustomArrow ariaLabel="slide anterior" left darken tabIndex={0} />
      }
      nextArrow={<CustomArrow ariaLabel="próximo slide" darken tabIndex={0} />}
      responsive={[
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]}
      className={className}
    >
      {children &&
        filteredImages.map((image, index) => (
          <div key={index}>
            <ImageWrapper shouldStretchVertical={shouldStretchVertical}>
              {image}
            </ImageWrapper>
            {image && image.props && image.props.title && (
              <Text className="carousel-legend" marginTop="15px">
                {image.props.title}
              </Text>
            )}
          </div>
        ))}
    </Slider>
  );
};

Carousel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  shouldStretchVertical: PropTypes.bool,
  hasVerticalSpacing: PropTypes.bool
};

Carousel.defaultProps = {
  className: "",
  shouldStretchVertical: false,
  hasVerticalSpacing: true
};

const ImageWrapper = styled.div`
  background-color: ${props => props.theme.colors.greyBg};

  img {
    margin-left: auto;
    margin-right: auto;
    width: 100% !important;
    object-fit: cover;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    height: ${props => (props.shouldStretchVertical ? `600px` : `300px`)};

    margin-bottom: ${props => (props.shouldStretchVertical ? `-3px` : `0px`)};
    @media (max-width: 767px) {
      height: ${props => (props.shouldStretchVertical ? `60vh` : `300px`)};
    }
  }
`;

export default styled(Carousel)`
  padding-bottom: ${props =>
    props.hasVerticalSpacing ? props.theme.spacing.l : 0};
  padding-top: ${props => props.theme.spacing.xl1};
  padding-right: 0;
  padding-left: 0;

  .carousel-legend {
    font-size: 12px;
    color: ${props =>
      lighten(0.6, props.theme.components.carousel.legendColor)};
  }

  .slick-prev {
    left: ${props => (props.shouldStretchVertical ? `-35px` : `-25px`)};
  }
  .slick-next {
    right: ${props => (props.shouldStretchVertical ? `-35px` : `-25px`)};
  }
  .slick-next,
  .slick-prev {
    width: auto;
    height: 35px;
    top: calc(50% - (35px / 2));
  }

  .slick-next:before,
  .slick-prev:before {
    content: none;
  }

  .slick-dots {
    width: 100%;
    bottom: 0;
    position: relative;
    margin-top: 10px;
    text-align: right;
    padding: 0 15px;
  }

  .slick-dots li {
    margin: 0 5px;
    :last-child {
      margin-right: 0;
    }
  }

  .slick-dots li,
  .slick-dots li button {
    width: 8px;
    height: 8px;
  }

  .slick-dots li button:before {
    content: "";
    background-color: ${props => props.theme.components.carousel.dotsColor};
    width: 8px;
    height: 8px;
  }

  .slick-active {
    &:before {
      content: "";
      width: 0;
      height: 0;
    }
  }

  .slick-dots {
    li {
      &:before {
        height: 0;
      }
    }
  }
`;
